/** Infer FlowV2 HTTP verb and query vs post-data binding from the method signature. */

const QUERY_SAFE_TYPES = new Set([
    'string',
    'int',
    'bool',
    'boolean',
    'float',
    'double',
    'dobule',
    'long',
    'decimal',
    'datetime',
    'guid',
    'timespan',
]);

const POST_NAME_PREFIXES = ['save', 'create', 'add', 'update', 'put', 'send', 'set', 'import'];
const DELETE_NAME_PREFIXES = ['delete', 'remove'];

export function normalizeParamType(type) {
    return String(type || '').trim().toLowerCase();
}

export function isPostDataType(type) {
    const t = normalizeParamType(type);
    if (!t || QUERY_SAFE_TYPES.has(t))
        return false;
    if (t === 'json' || t === 'jsonobj' || t === 'dynamic' || t === 'object')
        return true;
    if (t.includes('[]') || t.startsWith('list<') || t.startsWith('ilist<'))
        return true;
    return true;
}

function startsWithPrefix(name, prefixes) {
    const n = String(name || '').trim();
    if (!n)
        return false;
    const lower = n.toLowerCase();
    return prefixes.some((p) => lower === p || (lower.startsWith(p) && n.length > p.length));
}

export function inferHttpVerb(methodName, parameters) {
    const inParams = (parameters || []).filter((p) => p && !p.Out);
    if (inParams.some((p) => isPostDataType(p.Type)))
        return 'POST';
    if (startsWithPrefix(methodName, DELETE_NAME_PREFIXES))
        return 'DELETE';
    if (startsWithPrefix(methodName, POST_NAME_PREFIXES))
        return 'POST';
    return 'GET';
}

export function describeHttpBinding(methodName, parameters) {
    const verb = inferHttpVerb(methodName, parameters);
    const list = Array.isArray(parameters) ? parameters : [];
    const queryParams = [];
    const bodyParams = [];
    const outParams = [];

    for (const p of list) {
        if (!p || !String(p.Name || '').trim())
            continue;
        const name = String(p.Name).trim();
        if (p.Out) {
            outParams.push(name);
            continue;
        }
        if (verb === 'POST' && isPostDataType(p.Type))
            bodyParams.push(name);
        else
            queryParams.push(name);
    }

    return { verb, queryParams, bodyParams, outParams };
}

function joinNames(names) {
    if (names.length === 1)
        return names[0];
    if (names.length === 2)
        return `${names[0]} and ${names[1]}`;
    return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
}

export function formatHttpBindingHint(binding) {
    if (!binding)
        return '';
    const parts = [];
    if (binding.bodyParams.length && binding.queryParams.length)
        parts.push(`Callers send ${joinNames(binding.bodyParams)} as the JSON body and ${joinNames(binding.queryParams)} as query string.`);
    else if (binding.bodyParams.length)
        parts.push(`Callers send ${joinNames(binding.bodyParams)} as the JSON body.`);
    else if (binding.queryParams.length)
        parts.push(`Callers pass ${joinNames(binding.queryParams)} as query string.`);
    else
        parts.push('This method has no inbound parameters.');

    if (binding.outParams.length)
        parts.push(`${joinNames(binding.outParams)} ${binding.outParams.length === 1 ? 'is' : 'are'} out and not part of the request.`);

    return parts.join(' ');
}

export function paramBindingLabel(param, verb) {
    if (!param)
        return '';
    if (param.Out)
        return 'Out (not in the request)';
    if (verb === 'POST' && isPostDataType(param.Type))
        return 'JSON body (post data)';
    return 'Query string';
}
